import type { Comic } from '@/mocks/comics';

interface RankingSidebarProps {
  comics: Comic[];
}

export function RankingSidebar({ comics }: RankingSidebarProps) {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200/70 p-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg font-heading text-foreground-950">
          人气排行
        </h3>
        <span className="px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
          TOP 10
        </span>
      </div>
      <div className="space-y-1">
        {comics.map((comic, index) => (
          <a
            key={comic.id}
            href={`/comic/${comic.id}`}
            className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-background-100 transition-colors group cursor-pointer"
          >
            <div
              className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${
                index === 0
                  ? 'bg-accent-500 text-background-50'
                  : index === 1
                  ? 'bg-accent-300 text-background-50'
                  : index === 2
                  ? 'bg-accent-200 text-accent-800'
                  : 'bg-background-200 text-foreground-500'
              }`}
            >
              {index + 1}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </p>
              <p className="text-xs text-foreground-500 mt-0.5">
                {comic.category} · {comic.status}
              </p>
            </div>
            <div className="flex items-center gap-1 text-xs text-foreground-500 flex-shrink-0">
              <i className="ri-fire-line text-accent-500"></i>
              <span>{comic.views > 1000000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}</span>
            </div>
          </a>
        ))}
      </div>
      <a
        href="/category/all"
        className="flex items-center justify-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600 transition-colors"
      >
        查看更多排行
        <i className="ri-arrow-right-s-line"></i>
      </a>
    </div>
  );
}